export default __webpack_public_path__ + "static/ai-create-light-925e3ab26a323485554727d372803f607f8858380f442cd5ae673d3829be1aab.png";